export default {"src":"/_next/static/media/basketbal.41f8bd7f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};